export default __webpack_public_path__ + "media/icons/video-play-icon-f1eeb8fc.svg";